"use client";

import React from "react";
import Image from "next/image";
import { motion, type Variants } from "framer-motion";

const brands: { name: string; src: string }[] = [
  { name: "Stripe", src: "/logo/trustedby/stripe-svgrepo-com.svg" },
  { name: "Vercel", src: "/logo/trustedby/vercel-svgrepo-com.svg" },
  { name: "Balfour Beatty", src: "/logo/trustedby/Balfour_Beatty-Logo.wine.svg" },
  { name: "Bellway", src: "/logo/trustedby/Bellway-Logo.wine.svg" },
  { name: "Brookfield", src: "/logo/trustedby/Brookfield_Property_Partners-Logo.wine.png" },
  { name: "Dabur", src: "/logo/trustedby/Dabur-Logo.wine.svg" },
  { name: "JGC Corporation", src: "/logo/trustedby/JGC_Corporation-Logo.wine.png" },
  { name: "Keller Group", src: "/logo/trustedby/Keller_Group-Logo.wine.svg" },
  { name: "Kofax", src: "/logo/trustedby/Kofax-Logo.wine.svg" },
  { name: "Landsec", src: "/logo/trustedby/Landsec-Logo.wine.svg" },
  { name: "MTS", src: "/logo/trustedby/MTS_(network_provider)-Logo.wine.svg" },
  { name: "PCL Construction", src: "/logo/trustedby/PCL_Construction-Logo.wine.png" },
  { name: "Primary Health", src: "/logo/trustedby/Primary_Health_Properties-Logo.wine.png" },
  { name: "QinetiQ", src: "/logo/trustedby/Qinetiq-Logo.wine.svg" },
  { name: "Quest Software", src: "/logo/trustedby/Quest_Software-Logo.wine.svg" },
  { name: "Renewi", src: "/logo/trustedby/Renewi-Logo.wine.svg" },
  { name: "Safestore", src: "/logo/trustedby/Safestore-Logo.wine.svg" },
  { name: "Segro", src: "/logo/trustedby/Segro-Logo.wine.png" },
  { name: "Shaftesbury", src: "/logo/trustedby/Shaftesbury_plc-Logo.wine.svg" },
  { name: "Veritas", src: "/logo/trustedby/Veritas_Technologies-Logo.wine.svg" },
  { name: "World Food Programme", src: "/logo/trustedby/World_Food_Programme-Logo.wine.png" },
];

const allBrands = [...brands, ...brands];

const sectionVariants: Variants = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" as const } },
};

export default function TrustedBy() {
  return (
    <section className="relative w-full overflow-hidden py-16">
      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-8">
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mb-12 text-center"
        >
          <h2 className="text-2xl font-bold tracking-tight text-[var(--foreground)] sm:text-3xl">
            Trusted by over{" "}
            <span className="text-[var(--accent)]">500 Business Owners</span>
          </h2>
        </motion.div>

        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-[var(--background)] to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-[var(--background)] to-transparent" />

          <div className="marquee-track flex items-center gap-14">
            {allBrands.map((brand, i) => (
              <div
                key={`${brand.name}-${i}`}
                className="flex shrink-0 items-center rounded-xl bg-white px-5 py-3 shadow-sm"
              >
                <Image
                  src={brand.src}
                  alt={brand.name}
                  width={160}
                  height={55}
                  className="h-10 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
